module.exports = __webpack_public_path__ + "static/media/strike.37889c86.svg";